import { AuthByRefreshToken } from 'api/rolesAPICall';
import { utils_api } from 'generics/common';
import { getStartArgs, resetQuery } from 'generics/queryArgs.js';
import $ from 'jquery';
import 'jquery.cookie';

const TOKEN_KEY = ["AchievementApp", "auth", "tokenPair"];

export function loadTokenTuple()  {
  const stored = utils_api.getStored( TOKEN_KEY );
  if ( stored && ("object" === typeof stored) )  {
    const { token=null, steamAppId=null, steamId=null } = stored;
    if ( !!token )
      return { token, steamAppId, steamId };
  }
  return null;
}

export function loadCookieTokenTuple()  {
  const token = $.cookie('yutoken');
  if ( !!token )
    return { token, };
  return null;
}

export function storeToken( token, steamAppId, steamId, nick, app )  {
  utils_api.setStored( TOKEN_KEY, { token, steamAppId, steamId } );
  utils_api.sheduleReload( nick, app );
}

export function updateToken( token ) {
  let stored = utils_api.getStored( TOKEN_KEY );

  if (stored && ("object" === typeof stored))
    stored.token = token;
  else
    stored = { token };

  utils_api.setStored( TOKEN_KEY, stored );
}

export function resetToken( )  {
  utils_api.setStored( TOKEN_KEY, { token: null } );
}

export function detectSsoLanding()  {
  const { status }  =  getStartArgs();

  if ( status && ((+status) != 200) )
    return false;

  const { refresh_token }  =  getStartArgs();

  if ( refresh_token )
  {
    AuthByRefreshToken( refresh_token ).then((creds) => {
      const { jwt } = creds;

      if ( jwt )
      {
        const { app_id:steamAppId, steam_id:steamId, nick, app }  =  getStartArgs();
        storeToken( jwt, steamAppId, steamId, nick, app );
        resetQuery();
        return true;
      }
    })
  }

  return false;
}
